import { useTranslation } from 'react-i18next'
import { useAppDispatch } from '~/state/hooks'
import { useModalToggle } from '~/state/application/hooks'
import { ApplicationModal } from '~/state/application/reducer'
import { useSpotSwapUserConfig } from '~/state/dex/hooks'
import { updateSpotSwapUserConfig } from '~/state/dex/actions'
import { useGA, useUpdaterChainId } from '~/hooks'
import Switch from '~/components/Switch'
import { RowBetween } from '~/components/Layout'
import { isMainnetOrSepolia } from '~/utils/chain'
import styled from 'styled-components'
import {
  StyledLabelWrapper,
  StyledIcon,
  StyledIconQuestion,
  StyledLabel,
  StyledTips,
} from '../styled'
import IconCoin from '~/assets/images/coin.svg'
import IconQuestionMark from '~/assets/images/question-mark-gray.svg'

const PayGasFeeSetting: React.FC = () => {
  const { trackClick } = useGA()
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const chainId = useUpdaterChainId()
  const { sendByRelayer, isCrossSwap } = useSpotSwapUserConfig()
  const isMainnetOrSepoliaFlag = isMainnetOrSepolia(chainId)

  const enable = isMainnetOrSepoliaFlag && !isCrossSwap

  const toggleIntroModal = useModalToggle(
    ApplicationModal.PAY_WITH_TOKENS_INTRO,
    { stack: true },
  )

  const handleToggleSendOrder = () => {
    if (!enable) return

    trackClick('webtl_instant_setting_gasfeeswitch', {
      status: sendByRelayer ? 'off' : 'on',
    })
    dispatch(updateSpotSwapUserConfig({ sendByRelayer: !sendByRelayer }))
  }

  return (
    <StyledContainer disable={!enable}>
      <RowBetween>
        <StyledLabelWrapper>
          <StyledIcon src={IconCoin} />
          <StyledLabel>{t('set_gas_fee_label')}</StyledLabel>
          <StyledIconQuestion
            src={IconQuestionMark}
            onClick={toggleIntroModal}
          />
        </StyledLabelWrapper>
        <Switch checked={sendByRelayer} onChange={handleToggleSendOrder} />
      </RowBetween>
      <StyledTips>{t('set_gas_fee_tips')}</StyledTips>
    </StyledContainer>
  )
}

export default PayGasFeeSetting

const StyledContainer = styled.div<{ disable: boolean }>`
  padding: 16px 0;
  opacity: ${({ disable }) => (disable ? 0.5 : 1)};
  cursor: ${({ disable }) => (disable ? 'not-allowed' : 'auto')};
`
